import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import gql from 'graphql-tag';
import { calendarIcon } from '@justgiving/icons';
import usePageQuery, {
  buildQuery,
  UsePageQueryResult,
} from '../../hooks/usePageQuery';
import { EventDetailsFragment } from '../../../types/__generated__';
import IconLabel from '../IconLabel/IconLabel';

const FRAGMENT = buildQuery(gql`
  fragment EventDetails on Page {
    joinUrl
    relationships {
      events(first: 1) {
        totalCount
        nodes {
          title
          startDate
          endDate
          visible
        }
      }
    }
  }
`);

const EventDetails: FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });

  const result = usePageQuery<EventDetailsFragment>(FRAGMENT);

  if (
    !UsePageQueryResult.hasData(result) ||
    result.data?.relationships?.events.totalCount !== 1 ||
    !result.data.relationships.events.nodes[0]?.visible
  ) {
    return null;
  }

  const page = result.data;
  const events = result?.data?.relationships?.events.nodes;
  const event = events && events[0];
  const title = event?.title;
  const startDateString = event
    ? new Date(event.startDate).getTime().toString()
    : '';
  const endDateString = event
    ? new Date(event.endDate).getTime().toString()
    : '';

  const getLabel = () => {
    let label = t('page.eventLabel');
    let eventDetails = '';

    if (startDateString === endDateString) {
      eventDetails = t('page.eventDetailsSingleDay', {
        title,
        startDateString,
      });
    } else {
      eventDetails = t('page.eventDetailsMultiDay', {
        title,
        startDateString,
        endDateString,
      });
    }

    const startFundraisingLink = page?.joinUrl ? (
      <a href={page.joinUrl}>{t('page.eventStartFundraising')}</a>
    ) : (
      ''
    );

    return (
      <span>
        {label} {eventDetails} {startFundraisingLink}
      </span>
    );
  };

  return (
    <div data-qa="event-details">
      <IconLabel icon={calendarIcon} label={getLabel()} />
    </div>
  );
};

export default EventDetails;
